import {Inject, Injectable} from '@angular/core';
import {JwtHelper} from 'angular2-jwt';


@Injectable()
export class JwtService {

    constructor(@Inject(JwtHelper) private jwtHelper: JwtHelper) {
    }

    getToken(): string {
        return window.localStorage['jwtToken'];
    }

    saveToken(token: string) {
        window.localStorage['jwtToken'] = token;
    }

    destroyToken() {
        window.localStorage.removeItem('jwtToken');
    }

    decodeToken() {
        const token = this.getToken();
        if (token) {
            return this.jwtHelper.decodeToken(token);
        } else {
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/services/jwt.service.ts